var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"globeHolder",style:({'padding-left': _vm.showLeftPane? '175px': 0}),attrs:{"id":"globeHolder"}},[_c('div',{ref:"globe",attrs:{"id":"globe"}})])}
var staticRenderFns = []

export { render, staticRenderFns }